export default "__VITE_ASSET__CE$BkBG___"